import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    console.log("User registered:", formData);
    navigate("/login");
  };

  return (
    <div className="login-page py-5">
      <div className="container">
        <div className="col-md-6 mx-auto card p-4 shadow-lg rounded-4">
          <h3 className="text-center mb-4 main-color">Register</h3>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Full Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Password field */}
            <div className="mb-3 position-relative">
              <label className="form-label">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                name="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <i
                className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "42px",
                  cursor: "pointer",
                  color: "#007773",
                }}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>

            {/* Confirm password field */}
            <div className="mb-3 position-relative">
              <label className="form-label">Confirm Password</label>
              <input
                type={showConfirm ? "text" : "password"}
                className="form-control"
                name="confirmPassword"
                placeholder="Confirm your password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <i
                className={`fa-solid ${showConfirm ? "fa-eye-slash" : "fa-eye"}`}
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "42px",
                  cursor: "pointer",
                  color: "#007773",
                }}
                onClick={() => setShowConfirm(!showConfirm)}
              ></i>
            </div>

            <button
              type="submit"
              className="btn btn-outline-custom mt-2 w-100 rounded-3"
            >
              Register
            </button>

            <p className="text-center mt-3">
              Already have an account?{" "}
              <span
                className="main-color fw-bold"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/login")}
              >
                Login
              </span>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Register;
